import styled from '@emotion/styled';

const AvatarWrapper = styled.div`
  align-items: center;

  min-width: 32px;
  max-width: 48px;

  figure {
    margin: 0;
  }

  margin: 8px 0px 8px 0px;
`;

const SkeletonWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-around;

  [data-lift='lft-skeleton'] {
    &:last-child {
      max-width: 100px;
    }
  }
`;

const S = {
  AvatarWrapper,
  SkeletonWrapper,
};

export default S;
